<template>
    <div class="contained-page">
        <div class="contained-page-header">
            <slot name="header"></slot>
        </div>
        <div class="contained-page-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name : "ContainedPageLayout"
}
</script>

<style scoped lang="scss">
    .contained-page {
        display:flex;
        //the height of the topnav bar
        //height:calc(100% - 62px);
        height:100%;
        flex-flow:column nowrap;
        & > .contained-page-header {
            flex:none;
        }
        & > .contained-page-body {
            flex:1;
            //overflow-y:auto;
        }
    }
</style>
